import { Image, Row, Typography, Space, Col, } from "antd";
import React, { useEffect, useState } from "react";

import logo2 from "../../../Image/logo_checkuser.png"
export interface IDataEkyc {
    dataEkyc: any
    checkMessage: any
}
const CheckUser: React.FC<IDataEkyc> = ({ dataEkyc, checkMessage }): JSX.Element => {

    const [checkMessage1, setcheckMessage1] = useState<any>("");
    const params = new URLSearchParams(window.location.search);

    useEffect(() => {
        let idUser = params.get("check-data");
        setcheckMessage1(idUser);
    }, []);
    return (
        <div
            style={{
                backgroundColor: "#FFFFFF",
                height: "20vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Space direction="vertical">
                <Row>
                    <Col
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Image
                            alt="lodo"
                            src={logo2}
                            preview={false}
                            style={{
                                width: "120px",
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} className='mt-2'>
                        <Typography.Text
                            style={{
                                color: "#000000",
                                justifyContent: "center",
                                alignItems: "center",
                                display: "flex",
                            }}
                            className='size-16'
                        >

                            {checkMessage1 === "Invalid SharedToken" ? <div>"กรุณาเข้าสู่ระบบใหม่อีกครั้ง"</div> : "" ||
                                checkMessage === "Invalid Data" ? <div>"ท่านไม่มีคำขอประวัติการรักษา"</div> : "" ||
                                    dataEkyc === false ? <div>กรุณาทำ EKYC ในเมนู "ตั้งค่า" ของ OnePlatform</div> : ""
                            }
                        </Typography.Text>
                    </Col>
                </Row>
            </Space>
        </div>
    );
};

export default CheckUser;
